var WDN = WDN || {};

if (typeof WDN.SectionRenderer === "undefined") {
  WDN.SectionRenderer = (function () {
    var SectionRenderer;

    // Depends on
    var Request = WDN.Request;
    var Routes = Shopify.routes;

    SectionRenderer = function (config) {
      this.config = config;
      this.storeNodes();
      if (this.config.autoInit) {
        this.fetchSection();
        return;
      }
      this.init();
    };

    SectionRenderer.prototype.storeNodes = function () {
      this.outputs = document.querySelectorAll(this.config.selectors.output);
      // Option to pass nodes directly through config - as an array!
      if (this.config.triggers) {
        this.triggers = this.config.triggers;
        return;
      }
      this.triggers = document.querySelectorAll(this.config.selectors.trigger);
    };

    SectionRenderer.prototype.renderSections = function (response) {
      if (!response) return;
      var JSONResponse = JSON.parse(response);
      var content = [];

      for (var section in JSONResponse) {
        if (JSONResponse.hasOwnProperty(section)) {
          if (this.config.stripWrapper) {
            var domParser = new DOMParser().parseFromString(JSONResponse[section], "text/html");
            content.push(domParser.querySelector(".shopify-section").innerHTML);
          } else {
            content.push(JSONResponse[section]);
          }
        }
      }

      if (this.config.replaceOutput) {
        this.outputs.forEach(function (output) {
          output.innerHTML = content.join("");
        });

        return;
      }

      this.outputs.forEach(function (output) {
        output.insertAdjacentHTML("beforeend", content.join(""));
      });
    };

    SectionRenderer.prototype.handleFetchSuccess = function (response) {
      this.isFetching = false;
      this.renderSections(response);
      this.unbind();
      this.loading(false);
      this.complete = true;
      if (typeof this.config.callback !== "function") return;
      this.config.callback(this);
    };

    SectionRenderer.prototype.handleFetchError = function () {
      this.isFetching = false;
      this.loading(false);
    };

    SectionRenderer.prototype.getFetchURL = function () {
      if (this.config.customURL) return this.config.customURL;
      if (this.config.useCurrentRoot) {
        var UrlParams = new URLSearchParams(window.location.search);
        UrlParams.set("sections", this.config.sections.join(","));
        return window.location.pathname + "?" + UrlParams.toString();
      }

      return Routes.root + "?sections=" + this.config.sections.join(",");
    };

    SectionRenderer.prototype.fetchSection = function () {
      if (this.isFetching) return;
      this.isFetching = true;
      Request.Get({
        url: this.getFetchURL(),
        onSuccess: this.handleFetchSuccess.bind(this),
        onError: this.handleFetchError.bind(this),
      });
    };

    SectionRenderer.prototype.loading = function (state) {
      var action = state ? "add" : "remove";
      this.outputs.forEach(function (output) {
        output.classList[action]("loading");
      });
    };

    SectionRenderer.prototype.handleTriggerInteraction = function (e) {
      if (this.isFetching) return;
      this.loading(true);
      this.fetchSection();
    };

    SectionRenderer.prototype.unbind = function () {
      if (!this.binded) return;
      this.triggers.forEach(function (trigger) {
        if (!trigger) return;
        this.config.events.forEach(function (eventName) {
          trigger.removeEventListener(eventName, this.handleTriggerInteractionBound);
        }, this);
      }, this);
    };

    SectionRenderer.prototype.bind = function () {
      this.binded = true;
      this.handleTriggerInteractionBound = this.handleTriggerInteraction.bind(this);
      this.triggers.forEach(function (trigger) {
        if (!trigger) return;
        this.config.events.forEach(function (eventName) {
          trigger.addEventListener(eventName, this.handleTriggerInteractionBound);
        }, this);
      }, this);
    };

    SectionRenderer.prototype.init = function () {
      this.bind();
    };

    return SectionRenderer;
  })();
}
